import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "./__root";

export const inAppCheckoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/in_app_checkout",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "InAppCheckout" */ "@circle-react/components/OnboardingPage/InAppCheckoutPage"
      ),
    "InAppCheckoutPage",
  ),
});
